import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from 'xlsx';

const API_URL = "https://server.majestyfx.com/admin_fetch_withdraw_history.php";

export default function RejectedWithdrawals() {
  const [withdrawals, setWithdrawals] = useState([]);
  const [search, setSearch] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchRejectedWithdrawals = async () => {
    try {
      setLoading(true);
      setError("");
      const res = await axios.post(
        API_URL,
        { status: "rejected" },
        { headers: { "Content-Type": "application/json", Accept: "application/json" } }
      );
      if (res.data?.status === "success") {
        setWithdrawals(Array.isArray(res.data.data) ? res.data.data : []);
      } else {
        setError(res.data?.message || "Failed to fetch rejected withdrawals");
        setWithdrawals([]);
      }
    } catch (e) {
      setError(e?.response?.data?.error || e?.message || "Failed to connect to server");
      setWithdrawals([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRejectedWithdrawals();
  }, []);
const filteredWithdrawals = withdrawals.filter((w) => {
  const q = search.toLowerCase();

  return (
    String(w.request_id || "").toLowerCase().includes(q) ||
    String(w.email || "").toLowerCase().includes(q) ||
    String(w.trade_id || "").toLowerCase().includes(q) ||
    String(w.type || "").toLowerCase().includes(q) ||
    String(w.status || "").toLowerCase().includes(q) ||
    String(w.wallet_address || "").toLowerCase().includes(q)
  );
});

  const exportToExcel = () => {
    if (filteredWithdrawals.length === 0


) {
      alert('No data to export');
      return;
    }

    const exportData = withdrawals.map((w, idx) => ({
      '#': idx + 1,
      'Request ID': w.request_id,
      'Date & Time': w.created_at,
      'Email': w.email,
      'Trade ID': w.trade_id,
      'Amount': w.amount,
      'Payment Type': w.type,
      'Status': w.status,
      'Bank Details': w.bank_details || '-',
      'Admin Comment': w.admin_comment || '-',
      'Source': w.source || '-',
      'Wallet Address': w.wallet_address || '-'
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Rejected Withdrawals');
    XLSX.writeFile(wb, `Rejected_Withdrawals_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  const StatusBadge = ({ status }) => {
    const key = String(status).toLowerCase();
    const label = key === "approved" ? "Approved" : key === "pending" ? "Pending" : key === "rejected" ? "Rejected" : String(status);
    return <span className={`status-badge status-${key}`}>{label}</span>;
  };

  return (
    <div className="main-content">
      <div className="page-header">
        <div>
          <h2>Rejected Withdrawals</h2>
          <p className="subtitle">View all rejected withdrawal requests</p>
        </div>
        <div className="header-actions">
          <button className="btn blue" onClick={fetchRejectedWithdrawals} disabled={loading}>
            {loading ? "Refreshing..." : "Refresh"}
          </button>
          <button className="btn green" onClick={exportToExcel} disabled={loading || filteredWithdrawals.length === 0


}>
            Export to Excel
          </button>
        </div>
      </div>

      <div className="card">{/* Search Box */}
<div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
  <input
    type="text"
    placeholder="Search by email, trade id, request id..."
    value={search}
    onChange={(e) => setSearch(e.target.value)}
    style={{
      padding: "8px 12px",
      borderRadius: "6px",
      border: "1px solid #ddd",
      width: "280px",
      fontSize: "14px",
    }}
  />
</div>

        <div className="table-container">
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Request ID</th>
                <th>Date & Time</th>
                <th>Email</th>
                <th>Trade ID</th>
                <th>Amount</th>
                <th>Payment Type</th>
                <th>Status</th>
                <th>Bank Details</th>
                <th>Admin Comment</th>
                <th>Source</th>
                <th>Wallet Address</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="12" style={{ textAlign: "center" }}>Loading...</td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="12" style={{ color: "crimson", textAlign: "center" }}>{error}</td>
                </tr>
              ) : filteredWithdrawals.length === 0


 ? (
                <tr>
                  <td colSpan="12" style={{ textAlign: "center" }}>No rejected withdrawals found</td>
                </tr>
              ) : (
                filteredWithdrawals.map((w, idx) => (

                  <tr key={`${w.request_id}-${idx}`}>
                    <td>{idx + 1}</td>
                    <td>{w.request_id}</td>
                    <td>{w.created_at}</td>
                    <td>{w.email}</td>
                    <td>{w.trade_id}</td>
                    <td>{w.amount}</td>
                    <td>{w.type}</td>
                    <td><StatusBadge status={w.status} /></td>
                    <td>{w.bank_details || "-"}</td>
                    <td>{w.admin_comment || "-"}</td>
                    <td>{w.source || "-"}</td>
                    <td>
                      {w.wallet_address ? (
                        <span
                          className="copyable-address"
                          title="Click to copy"
                          style={{ cursor: 'pointer', color: '#2563eb', textDecoration: 'underline' }}
                          onClick={() => {
                            navigator.clipboard.writeText(w.wallet_address);
                          }}
                          onMouseOver={e => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                          onMouseOut={e => e.currentTarget.style.backgroundColor = ''}
                        >
                          {w.wallet_address.length > 20 ? `${w.wallet_address.substring(0, 20)}...` : w.wallet_address}
                        </span>
                      ) : (
                        '-'
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        </div>
      </div>
    </div>
  );
}
